// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Chart } from 'react-google-charts';
import moment from 'moment';
import getDefaultChartData from '../../helpers/getDefaultChartData';
import Modal from '../../components/Modal/Modal';
import { viewsPeriodOnChart } from '../../constants';
import styles from './ChartOfViews.scss';

export default class ChartOfViews extends Component {
  calcTicks = (maxValue) => {
    const ticks = [];
    const range = (maxValue < 10) ? 10 : maxValue;
    let step;

    if (maxValue <= 10) {
      step = 2;
    } else if (maxValue <= 50) {
      step = 5;
    } else {
      step = 10;
    }

    for (let i = step; i <= range; i += step) {
      ticks.push(i);
    }

    return ticks;
  };

  renderChart = (chartData) => {
    const values = !!chartData.length && chartData[0].events.map(({ count }) => count);
    const maxValue = values ? Math.max.apply(null, values) : 10;
    const ticks = this.calcTicks(maxValue);
    const { isRtl } = this.props;

    const options = {
      legend: 'none',
      curveType: 'function',
      pointSize: 6,
      vAxis: {
        minValue: 0,
        ticks
      },
      hAxis: {
        direction: isRtl ? -1 : 1
      },
      tooltip: {
        isHtml: true,
        trigger: 'selection'
      },
      series: {
        0: { targetAxisIndex: Number(isRtl) }
      }
    };

    const views = this.props.translate('views').toString();
    const data = !!chartData.length && chartData[0].events.map(({ count, date }) => [moment(date).format('DD.MM'), count]);

    if (!data) { return true; }

    data.unshift(['Date', views]);

    return (
      <div className={styles.chartWrapper}>
        <Chart
          chartType="AreaChart"
          data={data}
          options={options}
          width="750px"
          height="300px"
          curveType="none"
          axisTitlesPosition="none"
        />
      </div>
    );
  };

  renderDescription = () => {
    const {
      translate,
      propertiesAnalytics: {
        publishDate,
        propertyViews = 0,
        chartData = [],
        analyticsAction = ''
      }
    } = this.props;

    const title = translate(`property_${analyticsAction}_stats`).replace('quantity', viewsPeriodOnChart);

    const periodAmount = (chartData.length) ?
      chartData[0].events
        .reduce(({ count: prevCount }, { count: currCount }) => ({ count: prevCount + currCount })).count
      : 0;

    const amountOfLastPeriod = translate(`amountLast_${analyticsAction}_period`)
      .replace('quantity', viewsPeriodOnChart)
      .replace('periodAmount', periodAmount);

    return (
      <div className={styles.chartDescription}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>
          <div>{propertyViews} {translate(`amountProperty_${analyticsAction}`)} ({publishDate})</div>
          <div>{amountOfLastPeriod}</div>
        </div>
      </div>
    );
  };

  render() {
    const { isViewsChartOpen, chartData } = this.props.propertiesAnalytics;
    const chart = chartData && chartData.length ? chartData : getDefaultChartData();

    return (
      <Modal
        isOpen={isViewsChartOpen}
        onRequestClose={this.props.onRequestClose}
        className="viewsChartModal"
        contentLabel="Chart Views Modal"
        isRtl={this.props.isRtl}
      >
        { isViewsChartOpen && this.renderDescription() }
        { isViewsChartOpen && chartData && this.renderChart(chart) }
      </Modal>
    );
  }
}

ChartOfViews.propTypes = {
  onRequestClose: PropTypes.func,
  isRtl: PropTypes.bool,
  translate: PropTypes.func,
  propertiesAnalytics: PropTypes.object
};
